import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Endpoints } from '../../../api/Constants';
import { postLoginActions } from './utils';
import { LoginResponseKeys } from '../../../api/Constants';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import Logger from '../../../lib/analytics/logger';
import Screens from '../../../screens';
import utils from '../../../utils';
import audio from '../../../utils/audio';
import { AUTH_TYPES } from '../../../utils/authFlow/constants';
import gameVersion from '../../../utils/gameVersion';
import navigation from '../../../utils/navigation/navigation';
import routeParamConstants from '../../../utils/routeParamConstants';
import { setAuthorized, setRestart, setToken } from '../../actions/auth';
import { setCasinoId, setPlayerId } from '../../actions/playerInfo';
import { handleAuthenticationErrorEvents } from '../handleLoggerErrorEvents';
export var postLoginMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.LOGIN),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  invalidatesTags: [{
    type: 'Login'
  }],
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args, _ref) {
      var dispatch, queryFulfilled, _yield$queryFulfilled, _yield$queryFulfilled2, success, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
            _context.prev = 1;
            _context.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled = _context.sent;
            _yield$queryFulfilled2 = _yield$queryFulfilled.data;
            success = _yield$queryFulfilled2.success;
            data = _yield$queryFulfilled2.data;
            if (success) handleLoginSuccess(dispatch, data, args === null || args === void 0 ? void 0 : args.login_type);
            if (!success) handleAuthenticationErrorEvents(data, args === null || args === void 0 ? void 0 : args.login_type);
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            handleAuthenticationErrorEvents(_context.t0, args === null || args === void 0 ? void 0 : args.login_type);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    }));
    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postSSOLoginMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.SSO_LOGIN),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  invalidatesTags: [{
    type: 'Login'
  }],
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args, _ref2) {
      var dispatch, queryFulfilled, _yield$queryFulfilled3, data, redirectionUrl;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref2.dispatch, queryFulfilled = _ref2.queryFulfilled;
            _context2.prev = 1;
            _context2.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled3 = _context2.sent;
            data = _yield$queryFulfilled3.data;
            if (!data.success) {
              _context2.next = 10;
              break;
            }
            handleLoginSuccess(dispatch, data, AUTH_TYPES.MEMBER);
            _context2.next = 19;
            break;
          case 10:
            handleAuthenticationErrorEvents(data, AUTH_TYPES.MEMBER);
            redirectionUrl = data.error_code === 'bbe3api_ssolog_2' && data.ssoAccountActivationRedirectionURL;
            if (!redirectionUrl) {
              _context2.next = 18;
              break;
            }
            if (!utils.isReactNative()) {
              _context2.next = 15;
              break;
            }
            return _context2.abrupt("return", redirectionUrl);
          case 15:
            window.location = redirectionUrl;
            _context2.next = 19;
            break;
          case 18:
            navigation.navigate(Screens.Start, _defineProperty({}, routeParamConstants.PARAM_STATUS_MESSAGE, data.error));
          case 19:
            _context2.next = 24;
            break;
          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](1);
            handleAuthenticationErrorEvents(_context2.t0, AUTH_TYPES.MEMBER);
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 21]]);
    }));
    function onQueryStarted(_x3, _x4) {
      return _onQueryStarted2.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postGuestLoginMutation = {
  query: function query(data) {
    return {
      url: "".concat(Endpoints.GUEST_LOGIN),
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, data), {}, {
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  invalidatesTags: [{
    type: 'Login'
  }],
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(args, _ref3) {
      var dispatch, queryFulfilled, _yield$queryFulfilled4, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch = _ref3.dispatch, queryFulfilled = _ref3.queryFulfilled;
            _context3.prev = 1;
            _context3.next = 4;
            return queryFulfilled;
          case 4:
            _yield$queryFulfilled4 = _context3.sent;
            data = _yield$queryFulfilled4.data;
            Logger.sendEvent(EVENT_TYPES.REGISTRATION_COMPLETE, {
              type: AUTH_TYPES.GUEST
            });
            handleLoginSuccess(dispatch, data, AUTH_TYPES.GUEST);
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](1);
            handleAuthenticationErrorEvents(_context3.t0, AUTH_TYPES.GUEST);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 10]]);
    }));
    function onQueryStarted(_x5, _x6) {
      return _onQueryStarted3.apply(this, arguments);
    }
    return onQueryStarted;
  }()
};
export var postCheckIfEmailExistsMutation = {
  query: function query(email) {
    return {
      url: Endpoints.CHECK_IF_EMAIL_EXISTS,
      method: 'post',
      body: {
        data: {
          email: email,
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  }
};
export var postSsoUpgradeMutation = {
  query: function query(_ref4) {
    var userStatus = _ref4.userStatus,
      email = _ref4.email,
      password = _ref4.password,
      userInfo = _ref4.userInfo;
    return {
      url: Endpoints.SSO_UPGRADE,
      method: 'post',
      body: {
        data: _objectSpread(_objectSpread({}, userInfo), {}, {
          userStatus: userStatus,
          email: email,
          password: password,
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        })
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  }
};
export var postSsoInitLinkLoyaltyCardQuery = {
  query: function query(tokenValue) {
    return {
      url: Endpoints.SSO_INIT_LINK_LOYALTY_CARD,
      method: 'post',
      body: {
        data: {
          tokenType: 'authCode',
          tokenValue: tokenValue,
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response[0];
  }
};
export var postSsoLinkLoyaltyCardMutation = {
  query: function query(_ref5) {
    var email = _ref5.email,
      ssoRefreshToken = _ref5.ssoRefreshToken,
      ssoAccessToken = _ref5.ssoAccessToken,
      casinoId = _ref5.casinoId;
    return {
      url: Endpoints.SSO_LINK_LOYALTY_CARD,
      method: 'post',
      body: {
        data: {
          email: email,
          ssoRefreshToken: ssoRefreshToken,
          casinoId: casinoId,
          ssoAccessToken: ssoAccessToken,
          platform: utils.getPlatform(),
          bundlever: gameVersion()
        }
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response[0];
  }
};
export var getWebTrackingUrlDataQuery = {
  query: function query(aff_id) {
    return {
      url: "".concat(Endpoints.TRACKING_URL, "/").concat(aff_id),
      method: 'get'
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  }
};
var handleLoginSuccess = function handleLoginSuccess(dispatch, data) {
  var loginMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : AUTH_TYPES.MEMBER;
  postLoginActions(loginMethod, true);
  if ((data === null || data === void 0 ? void 0 : data.is_new_account) === true || (data === null || data === void 0 ? void 0 : data.is_new_account) === 'yes') Logger.sendEvent(EVENT_TYPES.REGISTRATION_COMPLETE, {
    type: loginMethod
  });
  dispatch(setPlayerId((data === null || data === void 0 ? void 0 : data.playerId) || (data === null || data === void 0 ? void 0 : data.player_id) || data[LoginResponseKeys.PLAYER_ID]));
  dispatch(setCasinoId((data === null || data === void 0 ? void 0 : data.casinoId) || (data === null || data === void 0 ? void 0 : data.casino_id) || data[LoginResponseKeys.CASINO_ID]));
  dispatch(setAuthorized(true));
  dispatch(setToken((data === null || data === void 0 ? void 0 : data.sessionId) || (data === null || data === void 0 ? void 0 : data.session_id) || data[LoginResponseKeys.AUTH_TOKEN]));
  dispatch(setRestart((data === null || data === void 0 ? void 0 : data.restartToken) || (data === null || data === void 0 ? void 0 : data.restart_token) || data[LoginResponseKeys.RETURN_TOKEN]));
  navigation.navigate(Screens.Lobby);
  audio.fadeOut('crowdsTalking');
  audio.playMusic('backgroundMusic');
};